import React from 'react';
import { normDateToAmericanDateTime } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import AssigneesBlock from 'components/common/group/content/AssigneesBlock';
import { observer } from 'mobx-react-lite';
import { createCommonDashboardCells } from 'components/common/enrollment/Dashboard';
import { BiDashboardGroupDelegate } from 'store/pages/bi-groups-dashboard/biDashboardGroupDelegate';
import { useBiDashboardPageStore } from 'store/pages/bi-groups-dashboard/pageStore';
import { toJS } from 'mobx';
import { ActionCellStyled, GroupNumberStyled, TableCellStyled, TableRowStyled } from './styles';
import MoreDropdown from '../MoreDropdown';

interface Props {
  groupDelegate: BiDashboardGroupDelegate;
}

const BiTableRow: React.FC<Props> = observer(({ groupDelegate }) => {
  const {
    paginationDelegate: { filters },
    isLoading,
  } = useBiDashboardPageStore();

  const { id, name, assigned, agentOfRecord, lastUpdateTime, agency, enrollments, contactInfo, carrierGroupNumber } =
    groupDelegate.data;
  const convertedEnrollments = enrollments.slice().map((enrollment) => toJS(enrollment));

  const commonCells = createCommonDashboardCells(convertedEnrollments, isLoading ? null : filters.filter);
  return (
    <TableRowStyled key={id}>
      <TableCellStyled width="4rem">{contactInfo.primaryAddress.state}</TableCellStyled>
      <TableCellStyled>{agency.name}</TableCellStyled>
      <TableCellStyled>
        {name} {carrierGroupNumber && <GroupNumberStyled>({carrierGroupNumber})</GroupNumberStyled>}
      </TableCellStyled>
      <TableCellStyled>{commonCells.effectiveDates}</TableCellStyled>
      <TableCellStyled>{commonCells.productLines}</TableCellStyled>
      <TableCellStyled width="6rem">{commonCells.stages}</TableCellStyled>
      <TableCellStyled width="8rem">
        <AssigneesBlock agentOfRecord={agentOfRecord} assigned={assigned || []} />
      </TableCellStyled>
      <TableCellStyled>{normDateToAmericanDateTime(lastUpdateTime)}</TableCellStyled>
      <ActionCellStyled width="5rem">
        <MoreDropdown groupDelegate={groupDelegate} />
      </ActionCellStyled>
    </TableRowStyled>
  );
});

export default BiTableRow;
